module.exports = __webpack_public_path__ + "img/turkish_delight.6b8da768.svg";